import { writable } from "svelte/store";

export const errors = writable<string[]>([]);

export function applyError(fieldName: string): void {
    errors.update(errorState => {
        if (!errorState.includes(fieldName)) {
            errorState = [...errorState, fieldName];
        }

        return errorState;
    });
}

export function removeError(fieldName: string): void {
    errors.update(errorState => {
        errorState = errorState.filter((name) => name != fieldName);
        return errorState;
    });
}